"use client";

import dynamic from "next/dynamic";

const Inspector = dynamic(() => import("@/components/Inspector"), { ssr: false });

export default function ClientShell() {
  if (process.env.NODE_ENV !== "development") return null;
  return <Inspector />;
}
